import e from "./ghl-ui.es814.js";
import i from "./ghl-ui.es815.js";
import a from "./ghl-ui.es373.js";
function t(r) {
  return a(r) ? e(r, !0) : i(r);
}
export {
  t as default
};
